import { useTranslation } from 'react-i18next'

import ptb from '../../../Assets/Home/ptb.png'
import UCASAL from '../../../Assets/Logos/UCASAL.png'
import LogoHorizontal from '../../../Assets/Logos/logo_horizontal_usound.svg'

export default function Ptb() {

    const commonStyles = {
        fontSize: "1rem",
        padding: "7px 40px",
        border: "none",
        cursor: "pointer",
    }

    const [t, i18n] = useTranslation('global')

    return (
       
        <section id="ptb" className='pb-5'>
             
            <div className='row justify-content-center'>
                <div className='col-10 col-lg-8 pt-5'>
                    <h4 className='fw-bold text-center fs-1 pt-5 pb-3'>
                        {t('home.ptb.title')}
                    </h4>
                    <div className="card" style={{borderRadius: '30px', backgroundColor: '#e5e5e5', border: 'none'}}>
                        <div className="card-body text-center text-lg-start p-4" style={{ color: '#4e4e4e' }}>
                            <p className="pt-2 fs-5">
                                {t('home.ptb.description_1')}
                            </p>
                            <p className="pt-2 fs-5">
                                {t('home.ptb.description_2')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row justify-content-center pt-5'>
                <div className='col-10 col-lg-4'>
                    <img id='collageretspl' src={ptb} alt="ptb" style={{ width: "100%" }}/>
                </div>
                <div className='col-10 col-lg-4 d-flex align-items-center'>
                    <button
                        type='button'
                        onClick={() => window.open(t('home.ptb.link_button'), '_blank')}
                        className="usxsBtn"
                        style={{
                            backgroundColor: "#18F0C9"
                        }}
                    >
                        {t('home.ptb.button')}
                    </button>
                </div>
            </div>
        </section>
    )
}